// import { Ref } from 'vue';
import dayjs from 'dayjs';
import { requestUrl, ossUrl } from '@/config/app';
import { isIE9 } from '@/utils/tool';

const getBlob = (url) => {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };

    xhr.send();
  });
};
const saveAs = (blob, filename) => {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    const body = document.querySelector('body');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    // fix Firefox
    link.style.display = 'none';
    // @ts-ignore
    body.appendChild(link);
    link.click();
    // @ts-ignore
    body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }
};
export const downloadUrl = async (url, fileName) => {
  const blob = await getBlob(url);
  saveAs(blob, fileName);
};

export const download = async (info, typeID) => {
  const filename =
    info.bidder_date.split('年')[1] +
    info.bidder +
    '-' +
    info.prefix +
    info.code +
    '-' +
    info.project.replace(/\./, '')+".pdf";
  let url = '';
  if (info.status == 5 || info.status == 13 || info.status == 7) {
    url = ossUrl + (!typeID ? info.sign_file_path : info.sign_file_path2);
  } else {
    url = ossUrl + (!typeID ? info.file_path : info.file_path2);
  }
  if (isIE9()) {
    window.location.href = url;
  } else {
    await downloadUrl(url, filename);
  }
};
